<template>
  <div>
    <div class="income-container finance-wrap">
      <el-form :inline="true" size="small">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-select filterable clearable v-model="query.merchantId" placeholder="账户名称" style="width: 100%;">
              <el-option v-for="item in accountList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <DateRangePicker :startDate.sync="query.startDate" :endDate.sync="query.endDate" style="width: 100%;">
            </DateRangePicker>
          </el-col>
          <el-col :span="5">
            <el-select clearable v-model="query.status" placeholder="审核状态" style="width: 100%;">
              <el-option label="等待审核" :value="0"></el-option>
              <el-option label="审核通过" :value="1"></el-option>
              <el-option label="审核失败" :value="-1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-input v-model="query.key" style="width: 100%;" placeholder="关键字"></el-input>
          </el-col>
          <el-col :span="4">
            <div class="box-input-btn">
              <el-button class="box-input-btn-cz" @click="resetQuery">重置</el-button>
              <el-button class="default" @click="onQueryextransactionrecord(1, 10)">查询</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div class="status-container">
          <div class="status-item status-all" :class="{ 'active': query.status == null }"
            @click="setActiveStatus(null)">
            全部{{ dataCount.pendingCount + dataCount.succeedCount + dataCount.failCount }}
          </div>
          <div class="status-item status-pending" :class="{ 'active': query.status === 0 }" @click="setActiveStatus(0)">
            待审批{{ dataCount.pendingCount }}
          </div>
          <div class="status-item status-paid" :class="{ 'active': query.status === 1 }" @click="setActiveStatus(1)">
            审批通过{{ dataCount.succeedCount }}
          </div>
          <div class="status-item status-unpaid" :class="{ 'active': query.status === -1 }"
            @click="setActiveStatus(-1)">
            审批失败{{ dataCount.failCount }}
          </div>
        </div>
        <div class="add-button-container">
          <div class="box-input-btn">
            <el-button class="box-input-btn-cz" @click="openAddDialog">添加付款</el-button>
          </div>
        </div>
        </div>
        <el-table :data="tableData"
          :header-cell-style="{ backgroundColor: '#F2F4F7', color: '#333', fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }"
          style="width: 100%" v-loading="loading" :height="'570px'" :cell-style="{ 'text-align': 'center' }">
          <el-table-column prop="accountName" label="账户名称" min-width="120">
          </el-table-column>
          <el-table-column prop="amount" label="金额" min-width="120">
          </el-table-column>
          <el-table-column prop="userName" label="申请人" min-width="120">
          </el-table-column>
          <el-table-column prop="createdTime" label="申请日期" min-width="180">
          </el-table-column>
          <el-table-column prop="accountInfo" label="收款账户信息" min-width="280">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: space-between;align-items: center;">
                <div class="source-type" v-if="scope.row.supplierName">供</div>
                <div style="width:calc(100% - 60px);">{{ scope.row.accountInfo || scope.row.supplierAccountInfo }}</div>
                <div v-if="scope.row.accountInfo || scope.row.supplierAccountInfo"><el-button size="small" type="primary" style="height:26px;line-height: 18px;padding:0 6px;" @click="copyAccountInfo(scope.row.accountInfo || scope.row.supplierAccountInfo)">复制</el-button></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="审批状态" min-width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" class="status-tag-solid approved">审核通过</span>
              <span v-else-if="scope.row.status == -1" class="status-tag-solid failed">审核失败</span>
              <span v-else-if="scope.row.status == 0" class="status-tag-solid pending">等待审核</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="支付用途" min-width="200">
          </el-table-column>
          <el-table-column prop="imageUrl" label="截图" min-width="120">
            <template slot-scope="scope">
              <el-image v-if="scope.row.imageUrl" :src="scope.row.imageUrl" :preview-src-list="[scope.row.imageUrl]"
                fit="cover" style="width: 70px;height:40px; cursor: pointer;"></el-image>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="audiRemark" label="审核备注" min-width="200">
          </el-table-column>
          <el-table-column prop="imageUrl" label="审核快照" min-width="120">
            <template slot-scope="scope">
              <el-image v-if="scope.row.auditUrl" :src="scope.row.auditUrl" :preview-src-list="[scope.row.auditUrl]"
                fit="cover" style="width: 70px;height:40px; cursor: pointer;"></el-image>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="150" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == 0" type="text" size="small"
                @click="handleConfirmExpend(scope.row)">确认付款</el-button>
              <el-button v-if="scope.row.status == 0" type="text" size="small" style="color: #F56C6C;"
                @click="handleCancelExpend(scope.row)">驳回付款</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-pagination">
          <el-pagination @current-change="currentChange" :current-page="query.page" :page-size="10"
            layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加对话框 -->
    <el-dialog title="新增付款" :visible.sync="addDialogVisible" width="600px" class="center-dialog">
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="130px">
        <el-form-item label="支付金额" prop="amount">
          <el-input v-model="addForm.amount" placeholder="请输入支付金额" @input="handleAmountInput"></el-input>
        </el-form-item>
        <el-form-item label="是否供应商" prop="isSupplier">
          <el-radio-group v-model="addForm.isSupplier">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="供应商" prop="supplierId" v-if="addForm.isSupplier">
          <el-select filterable clearable v-model="addForm.supplierId" placeholder="请选择供应商" style="width: 100%;">
            <el-option v-for="item in merchantList" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款账户信息" prop="accountInfo" v-if="!addForm.isSupplier">
          <el-input v-model="addForm.accountInfo" placeholder="收款账户信息" rows="3" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="支付用途" prop="remark">
          <el-input v-model="addForm.remark" type="textarea" placeholder="请输入支付用途" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="相关图片">
          <upload v-model="addForm.imageUrl" accept="img" :auto-upload="true" :image-url="addForm.imageUrl"
            :drag="'drag'" thisType="custom" @input="toImg($event, 'imageUrl')"
            :customSty="{ width: '430px', height: '154px' }">
          </upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveAddForm">保存</el-button>
      </span>
    </el-dialog>

    <!-- 备注对话框 -->
    <el-dialog :title="currentAction === 'confirm' ? '确认付款' : '驳回付款'" :visible.sync="remarkDialogVisible" width="500px">
      <el-form :model="remarkForm" :rules="remarkFormRules" ref="remarkFormRef" label-width="100px">
        <el-form-item label="付款金额">
          <div style="white-space: pre-line;">{{ selectedRow.amount }}</div>
        </el-form-item>
        <el-form-item label="备注">
          <div style="white-space: pre-line;">{{ selectedRow.remark || '-' }}</div>
        </el-form-item>
        <el-form-item label="收款账户信息">
          <div style="white-space: pre-line;">{{ remarkForm.supplierAccountInfo }}</div>
        </el-form-item>

        <el-form-item label="付款账户" prop="accountId" v-if="currentAction === 'confirm'">
          <el-select filterable clearable v-model="remarkForm.accountId" placeholder="付款账户" style="width: 100%;">
            <el-option v-for="item in accountList" :key="item.value" :label="item.label" :value="item.value">
              <span style="display: flex; justify-content: space-between; width: 100%;">
                <span>{{ item.label }}</span>
                <span style="color: #999; margin-left: 10px;">余额: {{ item.balance }}</span>
              </span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="付款备注" prop="audiRemark">
          <el-input v-model="remarkForm.audiRemark" type="textarea" :rows="3" placeholder="请输入备注信息"></el-input>
        </el-form-item>
        <el-form-item label="付款截图" v-if="currentAction === 'confirm'">
          <upload v-model="remarkForm.auditUrl" accept="img" :auto-upload="true" :image-url="remarkForm.auditUrl"
            :drag="'drag'" thisType="custom" @input="toImg($event, 'imageUrl')"
            :customSty="{ width: '360px', height: '154px' }">
          </upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRemark">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { queryextransactionrecord, addextransactionrecord, getQueryaccount, audiextransactionrecord, supplierlist } from '@/api/finance';
import { merchant } from '@/api/settings'
import upload from '@/components/upload.vue';
import DateRangePicker from '@/components/DateRangePicker.vue';
export default {
  data() {
    return {
      activeStatus: 'pending',
      addDialogVisible: false,
      remarkDialogVisible: false,
      remarkForm: {
        supplierAccountInfo: '',
        accountId: '',
        audiRemark: '',
        auditUrl: ''
      },
      currentAction: '',
      selectedRow: {},
      accountList: [],
      merchantList: [],
      addForm: {
        amount: '',
        remark: '',
        imageUrl: '',
        isSupplier: false,
        supplierId: '',
        accountInfo: ''
      },
      addFormRules: {
        amount: [
          { required: true, message: '请输入支付金额', trigger: 'blur' },
          { pattern: /^\d+(\.\d+)?$/, message: '请输入有效的数字金额', trigger: 'blur' }
        ],
        isSupplier: [
          { required: true, message: '请选择是否供应商', trigger: 'change' }
        ],
        supplierId: [
          { required: true, message: '请选择供应商', trigger: 'change' }
        ],
        accountInfo: [
          { required: true, message: '请输入收款账户信息', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入支付用途', trigger: 'blur' }
        ],
      },
      tableData: [],
      total: 0,
      query: {
        merchantId: '',
        page: 1,
        pageSize: 10,
        key: '',
        status: '',
        startDate: '',
      },
      dataCount: {
        failCount: 0,
        pendingCount: 0,
        succeedCount: 0
      }
    }
  },
  components: {
    DateRangePicker
  },
  computed: {
    remarkFormRules() {
      const rules = {};
      if (this.currentAction === 'confirm') {
        rules.audiRemark = [];
        rules.accountId = [
          { required: true, message: '请选择付款账户', trigger: 'change' }
        ];
      } else {
        rules.accountId = [];
        rules.audiRemark = [
          { required: true, message: '请输入备注信息', trigger: 'blur' }
        ];
      }
      return rules;
    }
  },
  methods: {
    copyAccountInfo(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.$message.success('复制成功');
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
      }
      document.body.removeChild(textarea);
    },
    toImg(e, type) {
      this.addForm[type] = e
    },
    handleAmountInput() {
      this.addForm.amount = this.addForm.amount.toString().replace(/[^\d.]/g, '');
      const parts = this.addForm.amount.split('.');
      if (parts.length > 2) {
        this.addForm.amount = parts[0] + '.' + parts.slice(1).join('');
      }
      if (parts[1] && parts[1].length > 2) {
        this.addForm.amount = parts[0] + '.' + parts[1].substring(0, 2);
      }
    },
    setActiveStatus(status) {
      this.query.status = status;
      this.query.page = 1;
      this.onQueryextransactionrecord();
    },
    resetQuery() {
      this.query = {
        page: 1,
        pageSize: 10,
        key: '',
        status: '',
        startDate: '',
        merchantId: '',
      };
      this.onQueryextransactionrecord();
    },
    openAddDialog() {
      this.addForm = {
        amount: '',
        remark: '',
        imageUrl: '',
        isSupplier: false,
        supplierId: '',
        accountInfo: '',
      };
      this.addDialogVisible = true;
    },
    saveAddForm() {
      this.$refs.addFormRef.validate(valid => {
        if (valid) {
          const accountInfo = this.addForm.accountInfo;
          this.addForm.accountInfo = accountInfo;
          if (!this.addForm.isSupplier) {
            this.addForm.supplierId = 0;
          }
          addextransactionrecord(this.addForm).then(res => {
            if (res.code == 1) {
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.addDialogVisible = false;
              this.query.page = 1;
              this.onQueryextransactionrecord();
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }
          })
        } else {
          return false;
        }
      });
    },
    handleConfirmExpend(row) {
      this.selectedRow = row;
      this.currentAction = 'confirm';
      this.remarkForm.supplierAccountInfo = row.supplierAccountInfo || row.accountInfo;
      this.remarkForm.accountId = '';
      this.remarkForm.audiRemark = '';
      this.remarkForm.auditUrl = '';
      this.remarkDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.remarkFormRef) {
          this.$refs.remarkFormRef.resetFields();
        }
      });
    },
    handleCancelExpend(row) {
      this.selectedRow = row;
      this.currentAction = 'cancel';
      this.remarkForm.supplierAccountInfo = row.supplierAccountInfo || row.accountInfo;
      this.remarkForm.accountId = 0;
      this.remarkForm.audiRemark = '';
      this.remarkForm.auditUrl = '';
      this.remarkDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.remarkFormRef) {
          this.$refs.remarkFormRef.resetFields();
        }
      });
    },
    submitRemark() {
      if (this.currentAction === 'confirm') {
        this.$refs.remarkFormRef.validate(valid => {
          if (valid) {
            audiextransactionrecord({
              id: this.selectedRow.id,
              flag: true,
              accountId: this.remarkForm.accountId,
              audiRemark: this.remarkForm.audiRemark,
              auditUrl: this.remarkForm.auditUrl
            }).then(res => {
              if (res.code == 1) {
                this.$message({
                  type: 'success',
                  message: '确认支出成功'
                });
                this.onQueryextransactionrecord();
              }
            });
            this.remarkDialogVisible = false;
          }
        });
      } else if (this.currentAction === 'cancel') {
        this.$refs.remarkFormRef.validate(valid => {
          if (valid) {
            audiextransactionrecord({
              id: this.selectedRow.id,
              flag: false,
              accountId: 0,
              audiRemark: this.remarkForm.audiRemark,
              auditUrl: this.remarkForm.auditUrl
            }).then(res => {
              if (res.code == 1) {
                this.$message({
                  type: 'success',
                  message: '取消支出成功'
                });
                this.onQueryextransactionrecord();
              }
            });
            this.remarkDialogVisible = false;
          }
        })

      }
    },
    currentChange(value) {
      this.query.page = value;
      this.onQueryextransactionrecord();
    },
    onQueryextransactionrecord(page, pageSize) {
      queryextransactionrecord({
        "MerchantId": this.query.merchantId,
        "Key": this.query.key,
        "Status": this.query.status,
        "StartDate": this.query.startDate,
        "EndDate": this.query.endDate,
        "Page.Index": page ? page : this.query.page,
        "Page.Size": pageSize ? pageSize : this.query.pageSize,
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.dataCount = {
          failCount:res.data.failCount,
          pendingCount:res.data.pendingCount,
          succeedCount:res.data.succeedCount,
        }
      })
    }
  },
  created() {
    getQueryaccount().then(res => {
      this.accountList = res.data.rows.map(t => {
        return {
          label: t.accountName,
          value: t.id,
          balance: t.balance,
        }
      });
    })
    supplierlist().then(res => {
      this.merchantList = res.data.map(t => {
        return {
          label: t.name,
          value: t.id,
        }
      });
    })
    this.onQueryextransactionrecord();
  }
}
</script>
<style scoped lang="scss">
.income-container {}

::v-deep .center-dialog {


  .el-dialog {
    margin-top: 80px !important;
  }
}

::v-deep .el-form--inline .el-form-item {
  display: flex;
  align-items: center;

  .el-form-item__label {
    width: 70px;
  }

  .el-form-item__content {
    width: calc(100% - 70px);
  }

}

.status-container {
  display: flex;
  margin-top: 20px;
  margin-bottom: 16px;

  .status-item {
    padding: 4px 12px;
    margin-right: 8px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 12px;
    background-color: transparent;

    &.status-all {
      border: 1px solid #409EFF;
      color: #409EFF;

      &.active {
        background-color: #409EFF;
        color: white;
      }
    }

    &.status-pending {
      border: 1px solid #E6A23C;
      color: #E6A23C;

      &.active {
        background-color: #E6A23C;
        color: white;
      }
    }

    &.status-paid {
      border: 1px solid #67C23A;
      color: #67C23A;

      &.active {
        background-color: #67C23A;
        color: white;
      }
    }

    &.status-unpaid {
      border: 1px solid #F56C6C;
      color: #F56C6C;

      &.active {
        background-color: #F56C6C;
        color: white;
      }
    }
  }

}

.status-tag-solid {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;

  &.approved {
    background-color: #67C23A;
    color: white;
  }

  &.failed {
    background-color: #F56C6C;
    color: white;
  }

  &.pending {
    background-color: #E6A23C;
    color: white;
  }
}

.snapshot-upload {
  width: 100%;
  height: 100px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
}

.table-pagination {
  margin-top: 15px;
  text-align: right;
}

.finance-wrap {
  // width: 953px;
  width: calc(100% - 30px);

  ::v-deep .el-select {
    margin-right: 5px;
    width: 125px;
  }

  ::v-deep .el-input__inner {
    background: #F2F4F7;
    border: none;
  }

  ::v-deep .el-table__row {
    .cell {
      font-size: 12px;
    }
  }

  ::v-deep .el-date-editor {
    margin-right: 5px;
    width: 240px;

    .el-range-input {
      background: transparent;
    }

    .el-range__close-icon {
      width: 10px;
    }
  }

  .box-table {
    height: calc(100% - 210px) !important;

    ::v-deep .el-table__body-wrapper {
      height: 100% !important;
      height: auto !important;
    }
  }

  .box-top {
    width: 593px;
    height: 81px;
    background: #FFFFFF;
    box-shadow: 0px 3px 12px 1px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 5px 10px;

    .top-item {
      width: 30%;

      p {
        color: #666;
        font-size: 12px;
      }

      .balance {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
      }

      .iconfont {
        vertical-align: middle;
        margin-right: 5px;
      }
    }
  }

}

.box-input-btn {
  text-align: right;

  .box-input-btn-cz {
    background: #EAF3FF;
    color: #3888E9;
    border: none;
  }

  .box-input-btn-add {
    background: #D8F5E4;
    color: #54D8A5;
    border: none;
  }
}
.source-type {
          display: inline-block;
          width: 18px;
          height: 18px;
          text-align: center;
          line-height: 18px;
          background: #4791ea;
          border-radius: 4px;
          color: #fff;
          font-size: 10px;
          margin-right: 5px;
        }
</style>
